import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-polyglot';
import Tooltip from './Tooltip';
import { Help } from '../icons';

import './HelpTooltip.css';

function HelpTooltip(props) {
  return (
    <Tooltip interactive html={props.html} arrow>
      <div className="tooltip-container">
        <Help className="tooltip-icon" altText={props.t('helpToolTip.label')} />
      </div>
    </Tooltip>
  );
}

HelpTooltip.propTypes = {
  html: PropTypes.node.isRequired,
  t: PropTypes.func.isRequired
};

export default translate()(HelpTooltip);



// WEBPACK FOOTER //
// ./src/components/edu/HelpTooltip.js